import {Component, EventEmitter, Output} from '@angular/core';
import {Overlayable} from "../../../interfaces/overlayable";

@Component({
  selector: 'brt-overlay-window-footer',
  templateUrl: './overlay-window-footer.component.html',
  styleUrls: ['./overlay-window-footer.component.scss']
})
export class OverlayWindowFooterComponent implements Overlayable {
  @Output('onClosed') onClosed = new EventEmitter<boolean>();

}
